import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-footer-modal',
    templateUrl: './footer-modal.component.html',
    styleUrls: ['./footer-modal.component.scss'],
    standalone: false
})
export class FooterModalComponent implements OnInit {
  public md: any = '';

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
